import React from 'react';
import PropTypes from 'prop-types';

const styles = {
  oneColumn: {
    display: 'grid', 
    gridTemplateColumns: '1fr',
  },
  twoColumns: {
    display: 'grid', 
    gridTemplateColumns: '1fr 1fr',
  },
  first: {
    gridColumn: '1',
    textAlign: 'center',
  },
  second: {
    gridColumn: '2',
    textAlign: 'center',
  },
};

class Body extends React.Component {
  render() {
    const { 
      columnContent, 
      leftColumnContent, 
      rightColumnContent
    } = this.props;

    return (
      <div>
        <div style={styles.oneColumn}>
          { columnContent &&
            <div style={styles.first}>
              {columnContent()}
            </div>
          }
        </div>
        <div style={styles.twoColumns}>
          { leftColumnContent &&
            <div style={styles.first}>
              {leftColumnContent()}
            </div>
          }
          { rightColumnContent &&
            <div style={styles.second}>
              {rightColumnContent()}
            </div>
          }
        </div>
      </div>
    );
  }
};

Body.propTypes = {
  columnContent: PropTypes.func,
  leftColumnContent: PropTypes.func,
  rightColumnContent: PropTypes.func,
}

export default Body;
